<template>
  <div>
    <container-headline
      :headline="$t('global.operatinginformation')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-4">
              <div class="form-group">
                <v-select
                  v-model="betrieb.hofangaben.hoflage"
                  label="bezeichnung"
                  :options="hoflage"
                  :disabled="!editable"
                  :placeholder="$t('global.locationofthecompany')"
                  :reduce="(r) => r.id"
                >
                  <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                </v-select>
                <label>{{ $t("global.locationofthecompany") }}</label>
              </div>
            </div>
            <div class="col-xl-2">
              <div class="form-group">
                <input
                  type="number"
                  min="0"
                  v-model.trim="betrieb.hofangaben.betriebsgroesse"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.farmsizeinha") }}</label>
              </div>
            </div>
            <div class="col-xl-2">
              <div class="form-group">
                <input
                  type="number"
                  min="0"
                  v-model.trim="betrieb.hofangaben.meterUeberMeer"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                  step="10"
                />
                <label>{{ $t("global.metersabove") }}</label>
              </div>
            </div>
            <div class="col-xl-4 form-group">
              <v-select
                v-model="betrieb.hofangaben.bewirtschaftungsarten"
                :options="bewirtschaftungsarten"
                :disabled="!editable"
                :placeholder="$t('global.managementtype')"
                label="bezeichnung"
                multiple
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>{{ $t("global.managementtype") }}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 form-group">
              <v-select
                v-model="betrieb.hofangaben.betriebszweige"
                :options="betriebszweige"
                :disabled="!editable"
                multiple
                :placeholder="$t('global.branchesofbusiness')"
                label="bezeichnung"
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>{{ $t("global.branchesofbusiness") }}</label>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="betrieb.hofangaben.weitereBetriebszweige"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.otherbranchesofbusiness") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 form-group">
              <v-select
                v-model="betrieb.hofangaben.tiere"
                :options="tiere"
                :disabled="!editable"
                multiple
                :placeholder="$t('global.animals')"
                label="bezeichnung"
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>{{ $t("global.animals") }}</label>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="betrieb.hofangaben.weitereTiere"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.furtheraanimals") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 form-group">
              <v-select
                v-model="betrieb.hofangaben.nebenbetriebe"
                :options="nebenbetriebe"
                :disabled="!editable"
                multiple
                :placeholder="$t('global.ancillaryoperations')"
                label="bezeichnung"
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>{{ $t("global.ancillaryoperations") }}</label>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="betrieb.hofangaben.detailsAgrotourismus"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.detailsagrotourism") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="betrieb.hofangaben.andererNebenbetrieb"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.otherancillaryoperations") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="betrieb.hofangaben.betriebshaftpflicht"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.publicliabilityinsurance") }}</label>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="betrieb.hofangaben.unfallversicherung"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.accidentinsurance") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <date-picker
                  date-format="dd.mm.yy"
                  :initial="betrieb.hofangaben.eintrittsdatum"
                  placeholder=" "
                  :show-icon="true"
                  :disabled="!editable"
                  @update="(val) => (betrieb.hofangaben.eintrittsdatum = val)"
                />
                <label>{{ $t("global.entrydate") }}</label>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <date-picker
                  date-format="dd.mm.yy"
                  :initial="betrieb.hofangaben.datumHofbesuch"
                  placeholder=" "
                  :show-icon="true"
                  :disabled="!editable"
                  @update="(val) => (betrieb.hofangaben.datumHofbesuch = val)"
                />
                <label>{{ $t("global.datefarmvisit") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <ckeditor
                  :editor="editor"
                  v-model="betrieb.hofangaben.bemerkung"
                  :disabled="!editable"
                  @blur="betrieb.hofangaben.bemerkung = replaceLinks(betrieb.hofangaben.bemerkung)"
                />
                <label>{{ $t("global.aboutus") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-check col-xl-12" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="betrieb.hofangaben.einverstaendnisWeitergabeDaten"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.consent") }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";
import DatePicker from "@/components/Datepicker";
import ClassicEditor from "/custom/custom_ckeditor/build/ckeditor";

import store from "@/store";
import { LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA } from "@/store/agriviva-firma/actions.type";
import replaceLinks from "@/utils/Text";

export default {
  name: "FirmaBetriebsangabenNewViva",
  components: {
    ContainerHeadline,
    DatePicker,
  },
  mixins: [],
  store,
  props: {
    betrieb: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      editor: ClassicEditor,
    };
  },
  computed: {
    hoflage() {
      if (this.$store) return this.$store.state.agrivivaFirma.hoflage;
      return [];
    },
    betriebszweige() {
      if (this.$store) return this.$store.state.agrivivaFirma.betriebszweige;
      return [];
    },
    bewirtschaftungsarten() {
      if (this.$store)
        return this.$store.state.agrivivaFirma.bewirtschaftungsarten;
      return [];
    },
    tiere() {
      if (this.$store) return this.$store.state.agrivivaFirma.tiere;
      return [];
    },
    nebenbetriebe() {
      if (this.$store) return this.$store.state.agrivivaFirma.nebenbetriebe;
      return [];
    },
  },
  watch: {},
  created() {},
  mounted() {
    if (this.hoflage?.length == 0)
      this.$store.dispatch(`agrivivaFirma/${LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA}`);
  },
  methods: {replaceLinks},
};
</script>
